import * as types from '../../../constants/actionTypes';

const initialState = {
    ambassadors: [],
    loading: false,
    errors: false,
};

export default function ambassadorsReducer(state = initialState, action) {
    switch (action.type) {
        case types.ADD_AMBASSADOR:
        case types.DELETE_AMBASSADOR:
        case types.UPDATE_AMBASSADOR_IMAGE:
        case types.EDIT_AMBASSADOR:
            return {
                ...state,
                loading: true,
            };

        case types.ADD_AMBASSADOR_FAIL:
        case types.DELETE_AMBASSADOR_FAIL:
        case types.UPDATE_AMBASSADOR_IMAGE_FAIL:
        case types.EDIT_AMBASSADOR_FAIL:
            return {
                ...state,
                errors: true,
                loading: false,
            };

        case types.ADD_AMBASSADOR_SUCCESS:
            return {
                ...state,
                errors: false,
                loading: false,
                ambassadors: [...state.ambassadors, action.result],
            };

        case types.DELETE_AMBASSADOR_SUCCESS:
            return {
                ...state,
                errors: false,
                loading: false,
                ambassadors: state.ambassadors.filter(
                    (item) => item.id !== action.ambassadorId
                ),
            };

        case types.UPDATE_AMBASSADOR_IMAGE_SUCCESS: {
            return {
                ...state,
                errors: false,
                loading: false,
                ambassadors: state.ambassadors.map((ambassador) =>
                    ambassador.id === action.ambassadorId
                        ? {
                              ...ambassador,
                              image: action.result.image,
                          }
                        : ambassador
                ),
            };
        }

        case types.EDIT_AMBASSADOR_SUCCESS: {
            return {
                ...state,
                errors: false,
                loading: false,
                ambassadors: state.ambassadors.map((ambassador) =>
                    ambassador.id === action.ambassadorId
                        ? {
                              ...ambassador,
                              ...action.result,
                          }
                        : ambassador
                ),
            };
        }

        default:
            return state;
    }
}
